import { useEffect, useCallback } from 'react';
import { whenIdle } from '@/utils/whenIdle';

export const usePylon = ({ appId, currUser }) => {
  const handleOnLoad = useCallback(() => {
    (() => {
      window.pylon = {
        chat_settings: {
          app_id: appId,
          email: currUser?.email,
          name: currUser?.first_name,
        },
      };
    })();
  }, [appId, currUser]);

  useEffect(() => {
    if (!appId) return undefined;

    const scriptId = 'pylon-widget-script';
    if (document.getElementById(scriptId)) return undefined;

    // The queue shim stays synchronous even though the script below does not.
    // `openSupportChat` no-ops when `window.Pylon` is missing, so deferring this
    // part would silently drop a support click made in the first second rather
    // than queueing it into `Pylon.q` the way the widget expects.
    if (!window.Pylon) {
      const Pylon = function () {
        Pylon.e(arguments);
      };
      Pylon.q = [];
      Pylon.e = function (args) {
        Pylon.q.push(args);
      };
      window.Pylon = Pylon;
    }

    // Only the widget fetch is deferred: Sentry measures it at p50 143ms /
    // p95 1,358ms on /jobs/:jobId, and nothing it renders is above the fold.
    let script = null;
    const cancelIdle = whenIdle(() => {
      script = document.createElement('script');
      script.id = scriptId;
      script.src = `https://widget.usepylon.com/widget/${appId}`;
      script.async = true;
      script.onload = () => handleOnLoad();

      document.body.appendChild(script);
    });

    return () => {
      cancelIdle();
      script?.remove();
    };
  }, [appId, handleOnLoad]);
};
